import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { RestService } from "src/app/core/services/rest.service";
import { AmplitudeService } from "src/app/core/services/amplitude.service";
import { UsersService } from "src/app/core/services/users.services";
import { ExternalAuthService } from "src/app/auth/external-auth.service";
import { AsideToggleService } from "../../services/aside-toggle.service";
import { ContractsFeatureService } from "src/app/modules/contracts/contracts-feature.service";
import { Subscription } from "rxjs";

@Component({
    selector: "app-aside",
    templateUrl: "./aside.component.html",
    styleUrls: ["./aside.component.scss"],
    standalone: false
})
export class AsideComponent implements OnInit, OnDestroy {
  header_logo: string;
  header_name: string;
  brevity_logo: string;
  subs: Subscription;
  isGroup = false;
  isGroupFirm = false;
  isItRole = false;
  isLogsRole = false;
  canSeeAdministration = false;
  canSeeContracts = false;
  currentYear = new Date().getFullYear().toString();

  constructor(
    public societiesService: RestService,
    public userS: UsersService,
    private _amplitudeService: AmplitudeService,
    private _authService: ExternalAuthService,
    public asideToggle: AsideToggleService,
    private router: Router,
    private contractsFeature: ContractsFeatureService
  ) {}

  ngOnInit(): void {
    this.brevity_logo = "./assets/media/logos/logo-light.png";

    const user = this._authService.getCurrentUser();
    const userInfo = this._authService.getCurrentUserInfo();
    this.isGroup = user.has_groups;
    this.isGroupFirm = user.firm.administration_groups;
    this.isItRole = userInfo?.role === 'it';
    this.isLogsRole = userInfo?.role === 'logs';
    this.canSeeAdministration = userInfo?.role === 'admin' || userInfo?.role === 'it';
    // Contratos v2 (DEVS-380): el item solo se muestra si la firm tiene el flag
    // `contracts_v2` activo. Punto de decisión único en ContractsFeatureService.
    this.canSeeContracts = this.contractsFeature.isV2Enabled();

    if (this.isItRole && this.router.url.startsWith('/companies')) {
      this.router.navigate(['/users']);
    }

    if (this.isLogsRole && this.router.url.startsWith('/companies')) {
      this.router.navigate(['/logs']);
    }

    if (user.firm) {
      this.getLogo(user.firm.id, user.firm.name);
      this._amplitudeService.setLoggedUser(user);
    }
  }

  ngOnDestroy(): void {
    this.subs?.unsubscribe();
  }

  onClickMenu(action: string): void {
    this._amplitudeService.setButtonMenuClicked({ action });
  }

  private getLogo(firm_id: number, firm_name: string): void {
    const imgUrl = `./assets/media/logos/${firm_id}.png`;

    this.fileExists(imgUrl, (exists: boolean) => {
      if (exists) {
        this.header_logo = imgUrl;
      } else {
        this.header_name = firm_name;
      }
    });
  }

  private fileExists(url: string, callback: (exists: boolean) => void): void {
    const img = new Image();
    img.src = url;

    if (img.complete) {
      callback(true);
    } else {
      img.onload = () => callback(true);
      img.onerror = () => callback(false);
    }
  }
}
